// import moment from "moment";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import activityConfig from "emun.activity/activity.config";
import orderConfig from "emun.order/order.config";
import graphHelper from "emun.activity/graph-helper";

class ActivityPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    var model = ($ctrl.model = options.model);
    $ctrl.bus = new ServiceBus();
    $ctrl.title = options.title || "Activity...";
    $ctrl.activityConfig = activityConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.localStorage = localStorage;
    $ctrl.contacts = [];
    $ctrl.$session = $session;
    $ctrl.alarmIntervals = [
      {
        id: 0,
        name: "None"
      },
      {
        id: 5,
        name: "5 minutes"
      },
      {
        id: 10,
        name: "10 minutes"
      },
      {
        id: 15,
        name: "15 minutes"
      },
      {
        id: 30,
        name: "30 minutes"
      },
      {
        id: 60,
        name: "1 hour"
      },
      {
        id: 120,
        name: "2 hours"
      },
      {
        id: 180,
        name: "3 hours"
      },
      {
        id: 240,
        name: "4 hours"
      },
      {
        id: 480,
        name: "8 hours"
      },
      {
        id: 720,
        name: "12 hours"
      },
      {
        id: 1440,
        name: "1 day"
      },
      {
        id: 2880,
        name: "2 days"
      },
      {
        id: 4320,
        name: "3 days"
      },
      {
        id: 10080,
        name: "1 week"
      },
      {
        id: 20160,
        name: "2 weeks"
      }
    ];

    $ctrl.onTextClick = function($event) {
      $event.target.select();
    };

    $ctrl.initGoogleClient = function() {
      gapi.client
        .init({
          discoveryDocs: [
            "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"
          ],
          clientId:
            "862791370095-ahmi0m3sckcj1ulmkuk5qp59epgp4j5q.apps.googleusercontent.com",
          scope: "https://www.googleapis.com/auth/calendar"
        })
        .then(function() {});
    };
    //        graphHelper.logout();
    $ctrl.processAuth = function() {
      // Add the required Authorization header with bearer token.
      resolve("$http").defaults.headers.common.Authorization =
        "Bearer " + localStorage.token;

      // This header has been added to identify our sample in the Microsoft Graph service. If extracting this code for your project please remove.
      resolve("$http").defaults.headers.common.SampleID =
        "angular-connect-rest-sample";

      if (localStorage.getItem("user") === null) {
        // Get the profile of the current user.
        graphHelper.me().then(function(response) {
          // Save the user to localStorage.
          let user = response.data;
          localStorage.setItem("user", angular.toJson(user));

          $ctrl.displayName = user.displayName;
          $ctrl.emailAddress = user.mail || user.userPrincipalName;
        });
      } else {
        let user = angular.fromJson(localStorage.user);

        $ctrl.displayName = user.displayName;
        $ctrl.emailAddress = user.mail || user.userPrincipalName;
      }
      if (localStorage.getItem("subscription") != null) {
        graphHelper.renewSubscription(localStorage.getItem("subscription"));
      }
    };

    if (activityConfig.googleApi) {
      gapi.load("client:auth2", $ctrl.initGoogleClient);
    }
    if (activityConfig.outlookApi) {
      if (localStorage.token) {
        $ctrl.processAuth();
      } else {
        graphHelper.login();
      }
    }

    $ctrl.timezones = activityConfig.timezones;

    if (!model.activity) {
      function round(date, duration, method) {
        return moment(Math[method](+date / +duration) * +duration);
      }
      var timezone = moment.tz.guess();
      var date = moment.tz(timezone);
      var startDate = round(date, moment.duration(30, "minutes"), "ceil");
      var endDate = startDate.add("minutes", 60);
      model.activity = {
        scheduledByUserName: $session.userName,
        scheduledForUserName: $session.userName,
        startDateString: startDate.format("MM/DD/YYYY hh:mm a"), //new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0),
        endDateString: endDate.format("MM/DD/YYYY hh:mm a"), //new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), 0)
        timeZone: $ctrl.getEmunTimezone(timezone),
        alarmInterval: 0
      };
      if (model.customer) {
        model.activity.retailerId = model.customer.id;
      }
      if (model.prospect) {
        model.activity.prospectId = model.prospect.id;
        model.activity.contact = model.prospect.name;
      }
      if (model.salesrep) {
        model.activity.scheduledForUserName = model.salesrep.id;
      }
      model.scheduledForUser = {
        userName: $session.userName,
        fullName: $session.fullName
      };
      model.scheduledByUser = {
        userName: $session.userName,
        fullName: $session.fullName
      };
    } else {
      if (!model.activity.timeZone || model.activity.timeZone == "") {
        var timezone = moment.tz.guess();
        model.activity.timeZone = $ctrl.getEmunTimezone(timezone);
      }
      model.activity.startDate = moment.tz(
        model.activity.startDate,
        this.getMomentTimezone(model.activity.timeZone)
      );
      model.activity.endDate = moment.tz(
        model.activity.endDate,
        this.getMomentTimezone(model.activity.timeZone)
      );
      model.activity.startDateString = model.activity.startDate.format(
        "MM/DD/YYYY hh:mm a"
      );
      model.activity.endDateString = model.activity.endDate.format(
        "MM/DD/YYYY hh:mm a"
      );

      if (model.activity.retailerId) {
        model.customer = {
          id: model.activity.retailerId,
          companyName: model.activity.customerNames
        };
      } else if (model.activity.prospectId) {
        model.prospect = {
          id: model.activity.prospectId,
          companyName: model.activity.customerName
        };
      }
      model.scheduledForUser = {
        userName: model.activity.scheduledForUserName,
        fullName: model.activity.scheduledForFullName
      };
      model.scheduledByUser = {
        userName: model.activity.scheduledByUserName,
        fullName: model.activity.scheduledByUserName
      };
    }

    if (model.defaultStarDate && model.defaultStarDate != undefined) {
      function round(date, duration, method) {
        return moment(Math[method](+date / +duration) * +duration);
      }

      var startDate = round(
        model.defaultStarDate,
        moment.duration(30, "minutes"),
        "ceil"
      );
      startDate = startDate.add("hours", 8);
      endDate = startDate.add("minutes", 60);
      model.activity.startDateString = startDate.format(
        "MM/DD/YYYY hh:mm a"
      );
      model.activity.endDateString = endDate.format(
        "MM/DD/YYYY hh:mm a"
      );
    }

    $ctrl.activityTypes = new AutoQuery({
      url: "QueryActivityTypes.json",
      orderBy: "Type",
      autoLoad: true,
      onLoaded: function(args) {
        if (model.activity) $ctrl.selectActivityType();
      },
      pageSize: 100
    });
	  $ctrl.prospectactivityTypes = new AutoQuery({
		  url: "QueryProspectActivityTypes.json",
		  orderBy: "Type",
		  autoLoad: true,
		  onLoaded: function (args) {
			  if (model.activity) $ctrl.selectActivityType();
		  },
		  pageSize: 100
	  });
    $ctrl.showCodes = new AutoQuery({
      url: "QueryShowCodes.json",
      orderBy: "Name",
      pageSize: 1000,
      autoLoad: true
    });
    $ctrl.scheduledByUserQuery = new AutoQuery({
      url: "QueryUsers.json?Username=" + $ctrl.model.scheduledByUser.userName,
      autoLoad: true,
      onLoaded: function(args) {
        if (args.results.length > 0) {
          $ctrl.model.scheduledByUser.fullName = args.results[0].fullName;
          $ctrl.model.scheduledByUser.email = args.results[0].email;
        }
      }
    });
    $ctrl.scheduledForUserQuery = new AutoQuery({
      url: "QueryUsers.json?Username=" + $ctrl.model.scheduledForUser.userName,
      autoLoad: true,
      onLoaded: function(args) {
        if (args.results.length > 0) {
          $ctrl.model.scheduledForUser.fullName = args.results[0].fullName;
          $ctrl.model.scheduledForUser.email = args.results[0].email;
        }
      }
    });
    if ($ctrl.model.customer) {
      var retailerQuery = new AutoQuery({
        url: "QueryRetailers.json?Id=" + $ctrl.model.customer.id,
        orderBy: "CompanyName",
        autoLoad: true,
        onLoaded: args => {
          $ctrl.model.customer = args.first;
        }
      });
      $ctrl.contactQuery = new AutoQuery({
          url: "QueryRetailerContacts.json?active=true&retailerId=" + $ctrl.model.customer.id,
        orderBy: "Name",
        pageSize: 1000,
        autoLoad: true,
        onLoaded: function(args) {
/*          if (args.total == 1) {
            $ctrl.contact = args.results[0];
            $ctrl.model.activity.contact = $ctrl.contact.name;
            $ctrl.model.activity.mobileNumber = $ctrl.contact.mobilePhone;
          }
*/
          $ctrl.contacts = [];
          args.results.forEach(function(contact) {
            $ctrl.contacts.push(contact);
            if (contact.name == $ctrl.model.activity.contact) {
              $ctrl.contact = contact;
              $ctrl.model.activity.contact = $ctrl.contact.name;
              $ctrl.model.activity.mobileNumber = $ctrl.contact.mobilePhone;
            }
          });
        }
      });
      $ctrl.locations = new AutoQuery({
        url:
          "QueryRetailerShippingLocations.json?Status=Active&retailerId=" +
          $ctrl.model.customer.id,
        orderBy: "Name",
        autoLoad: true,
        pageSize: 10,
        onLoaded(args) {
          if (args.total == 1) {
            $ctrl.location = args.results[0];
            $ctrl.model.activity.shipId = $ctrl.location.id;
          }
          args.results.forEach(function(location) {
            if (location.id == $ctrl.model.activity.shipId) {
              $ctrl.location = location;
              $ctrl.model.activity.shipId = $ctrl.location.id;
            }
          });
        }
      });
    }
    if ($ctrl.model.prospect) {
      var prospectQuery = new AutoQuery({
        url: "QueryProspects.json?Id=" + $ctrl.model.prospect.id,
        orderBy: "CompanyName",
        autoLoad: true,
        onLoaded: function(args) {
          //console.info("BL*** prospectQuery loaded");
          $ctrl.model.prospect = args.first;
          $ctrl.model.prospectName = $ctrl.model.prospect.companyName;
          //console.info(
          //  "BL*** prospect = " + JSON.stringify($ctrl.model.prospect)
          //);
          console.info('prospect name', $ctrl.model.prospectName);
          $ctrl.contact = {
            id: $ctrl.model.prospect.name,
            name: $ctrl.model.prospect.name
          };
          $ctrl.contacts = [];
          $ctrl.contacts.push($ctrl.contact);
        }
      });
    }
    $ctrl.updateOutlook = function(action) {
      var event = {
        id: $ctrl.model.activity.outlookId,
        subject: $ctrl.model.activity.title,
        Body: {
          ContentType: "HTML",
          Content: $ctrl.model.activity.note
        },
        location: {
          displayName: ""
        },
        start: {
          dateTime: $ctrl.model.activity.startDate,
          timeZone: $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
        },
        end: {
          dateTime: $ctrl.model.activity.endDate,
          timeZone: $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
        },
        //'attendees': [
        //    {
        //        "emailAddress": {
        //            "address": $ctrl.model.scheduledForUser.email,
        //            "name": $ctrl.model.scheduledForUser.fullName
        //        }
        //    }
        //],
        organizer: {
          emailAddress: {
            address: $ctrl.model.scheduledForUser.email,
            name: $ctrl.model.scheduledForUser.fullName
          }
        }
      };
      //if ($ctrl.model.customer) {
      //    event.location.displayName = $ctrl.model.customer.address + ', ' + $ctrl.model.customer.city + ', ' + $ctrl.model.customer.state + ' ' + $ctrl.model.customer.zip;
      //}
      if (action === "insert") {
        graphHelper.createEvent(event).then(function(response) {
          $ctrl.model.activity.outlookId = response.data.id;
          $ctrl.save(true);
        });
      } else if (action === "update") {
        graphHelper.updateEvent(event);
      } else if (action === "delete") {
        graphHelper.deleteEvent(event);
      }
    };
    $ctrl.updateGoogle = function(action) {
      var event = {
        id: $ctrl.model.activity.id.replace(/-/g, ""),
        summary: $ctrl.model.activity.title,
        description: $ctrl.model.activity.note,
        start: {
          dateTime: $ctrl.model.activity.startDate,
          timeZone: $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
        },
        end: {
          dateTime: $ctrl.model.activity.endDate,
          timeZone: $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
        },
        attendees: [{ email: $ctrl.model.scheduledForUser.email }]
      };

      if ($ctrl.model.customer) {
        event.location =
          $ctrl.model.customer.address +
          ", " +
          $ctrl.model.customer.city +
          ", " +
          $ctrl.model.customer.state +
          " " +
          $ctrl.model.customer.zip;
      }

      var isSignedIn = gapi.auth2.getAuthInstance().isSignedIn.get();

      if (action == "insert") {
        var request = gapi.client.calendar.events.insert({
          calendarId: "primary",
          resource: event
        });
        if (isSignedIn) {
          request.execute(function(event) {});
        } else {
          gapi.auth2
            .getAuthInstance()
            .signIn()
            .then(function(response) {
              request.execute(function(event) {});
            });
        }
      } else if (action == "update") {
        var request = gapi.client.calendar.events.update({
          calendarId: "primary",
          eventId: event.id,
          resource: event
        });
        if (isSignedIn) {
          request.execute(function(event) {});
        } else {
          gapi.auth2
            .getAuthInstance()
            .signIn()
            .then(function(response) {
              request.execute(function(event) {});
            });
        }
      } else if (action == "delete") {
        var request = gapi.client.calendar.events.delete({
          calendarId: "primary",
          eventId: event.id
        });
        if (isSignedIn) {
          request.execute(function(event) {});
        } else {
          gapi.auth2
            .getAuthInstance()
            .signIn()
            .then(function(response) {
              request.execute(function(event) {});
            });
        }
      }
    };
    $ctrl.$on("contactSaved", () => $ctrl.contactQuery.load(true));
  }

  resetOutlook() {
    localStorage.token = "";
    graphHelper.login();
  }

  findRetailers(val) {
    const $ctrl = this;
    let url = `QueryRetailersSearch.json?Take=5&Status=Active&Search=${val}&OrderBy=CompanyName`; //
    console.log("QueryRetailersSearch.$item", url);
    return $ctrl.bus.send(url).then(res => res.data.results);
  }

  findProspects(val) {
    const $ctrl = this;
    let url = `QueryProspects.json?Take=5&Search=${val}&OrderBy=CompanyName`;
    return $ctrl.bus.send(url).then(res => res.data.results);
  }

  findUsers(val) {
    const $ctrl = this;
    let url = `QueryUsers.json?Take=5&Search=${val}&OrderBy=FullName`;
    return $ctrl.bus.send(url).then(res => res.data.results);
  }

  getMomentTimezone(tz) {
    const $ctrl = this;
    var momentTimezone = $ctrl.timezones.filter(function(z) {
      return z.label === tz;
    });
    if (momentTimezone.length > 0) {
      return momentTimezone[0].id;
    } else {
      return tz;
    }
  }

  getEmunTimezone(tz) {
    const $ctrl = this;
    var momentTimezone = $ctrl.timezones.filter(function(z) {
      return z.id == tz;
    });
    if (momentTimezone.length > 0) {
      return momentTimezone[0].label;
    } else {
      return tz;
    }
  }

  selectRetailer(val) {
    const $ctrl = this;
    $ctrl.model.customer = val;

    if ((!$ctrl.model.activity.title || $ctrl.model.activity.title == undefined) && $ctrl.model.customer && $ctrl.model.customer != undefined && $ctrl.model.customer.companyName && $ctrl.model.activity != undefined && $ctrl.model.activity.type) {
      console.info(":hi1", activityConfig.defaultTitleCustomerFirst);
      if (!activityConfig.defaultTitleCustomerFirst) {
        $ctrl.model.activity.title = $ctrl.model.activity.type + ": " + $ctrl.model.customer.companyName;
      } else {
        $ctrl.model.activity.title = $ctrl.model.customer.companyName + ": " + $ctrl.model.activity.type;
      }
    }
    var retailerQuery = new AutoQuery({
      url: "QueryRetailers.json?Id=" + $ctrl.model.customer.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded: function(args) {
        $ctrl.model.customer = args.first;
        $ctrl.contactQuery = new AutoQuery({
          url:
            "QueryRetailerContacts.json?active=true&retailerId=" + $ctrl.model.customer.id,
          pageSize: 1000,
          orderBy: "Name",
          autoLoad: true,
          onLoaded(args) {
            //if (args.total == 1) {
            //	$ctrl.contact = args.results[0];
            //	$ctrl.model.activity.contact = $ctrl.contact.name;
            //}
            $ctrl.contacts = [];
            args.results.forEach(function(contact) {
              $ctrl.contacts.push(contact);
              if (contact.name == $ctrl.model.activity.contact) {
                $ctrl.contact = contact;
                $ctrl.model.activity.contact = $ctrl.contact.name;
              }
            });
          }
        });
        $ctrl.locations = new AutoQuery({
          url:
            "QueryRetailerShippingLocations.json?Status=Active&retailerId=" +
            $ctrl.model.customer.id,
          orderBy: "Name",
          autoLoad: true,
          pageSize: 10,
          onLoaded(args) {
            if (args.total == 1) {
              $ctrl.location = args.results[0];
              $ctrl.model.activity.shipId = $ctrl.location.id;
            }
            args.results.forEach(function(location) {
              if (location.id == $ctrl.model.activity.shipId) {
                $ctrl.location = location;
                $ctrl.model.activity.shipId = $ctrl.location.id;
              }
            });
          }
        });
      }
    });
  }

  selectProspect(val) {
    const $ctrl = this;
    $ctrl.model.prospect = val;
    var prospectQuery = new AutoQuery({
      url: "QueryProspects.json?Id=" + $ctrl.model.prospect.id,
      orderBy: "CompanyName",
      autoLoad: true,
      onLoaded: args => {
        $ctrl.model.prospect = args.first;
      }
    });
  }

	selectActivityType() {
		const $ctrl = this;
		if ($ctrl.model.prospectMode) {
			$ctrl.prospectactivityTypes.results.forEach(function (type) {
				if (type.type == $ctrl.model.activity.type) {
					$ctrl.activityType = type;
				}
			});
		} else {
			$ctrl.activityTypes.results.forEach(function (type) {
				if (type.type == $ctrl.model.activity.type) {
					$ctrl.activityType = type;
				}
			});
    }

    if ((!$ctrl.model.activity.title || $ctrl.model.activity.title == undefined) && $ctrl.model.customer && $ctrl.model.customer != undefined && $ctrl.model.customer.companyName && $ctrl.model.activity != undefined && $ctrl.model.activity.type) {
      console.info(":hi", activityConfig.defaultTitleCustomerFirst);
      if (!activityConfig.defaultTitleCustomerFirst) {
        $ctrl.model.activity.title = $ctrl.model.activity.type + ": " + $ctrl.model.customer.companyName;
      } else {
        $ctrl.model.activity.title = $ctrl.model.customer.companyName + ": " + $ctrl.model.activity.type;
      }
    }
  }

  selectTimeZone() {
    const $ctrl = this;
    $ctrl.model.activity.startDate = moment.tz(
      $ctrl.model.activity.startDate,
      $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
    );
    $ctrl.model.activity.endDate = moment.tz(
      $ctrl.model.activity.endDate,
      $ctrl.getMomentTimezone($ctrl.model.activity.timeZone)
    );
  }

  selectContact() {
    const $ctrl = this;
    $ctrl.contactQuery.results.forEach(function(contact) {
      if (contact.name == $ctrl.model.activity.contact) {
        $ctrl.contact = contact;
        $ctrl.model.activity.contact = $ctrl.contact.name;
        $ctrl.model.activity.mobileNumber = $ctrl.contact.mobilePhone;
      }
    });
  }

  selectLocation() {
    const $ctrl = this;
    $ctrl.locations.results.forEach(function(location) {
      if (location.id == $ctrl.model.activity.shipId) {
        $ctrl.location = location;
      }
    });
  }

  setEndDate() {
    const $ctrl = this;
    if ($ctrl.model.activity.startDate) {
      $ctrl.model.activity.endDate = $ctrl.model.activity.startDate
        .clone()
        .add("minutes", 60);
    }
  }
  commitActivity(a) {
    let $ctrl = this;
    $ctrl.bus
      .send("CreateActivity.json?jsconfig=ua,uaa", a)
      .then(function(response) {
        $ctrl.$emit("activitySaved", $ctrl);
        $ctrl.model.activity.id = response.data.id;
        if (
          activityConfig.googleApi &&
          $ctrl.model.activity.scheduledByUserName ===
            $ctrl.model.activity.scheduledForUserName
        ) {
          $ctrl.updateGoogle("insert");
        }
        if (
          activityConfig.outlookApi &&
          localStorage.token &&
          $ctrl.model.activity.scheduledByUserName ===
            $ctrl.model.activity.scheduledForUserName
        ) {
          $ctrl.updateOutlook("insert");
        }
        if (close) {
          $ctrl.$close($ctrl.model);
        }
      });
  }
  startOrder() {
    const $ctrl = this;
    $ctrl.$cart.createPrompt({
      retailer: $ctrl.model.customer,
      paymentTermsId: $ctrl.model.customer.paymentTerms,
      status: "Cart",
    });
    $ctrl.$close($ctrl.model);
  }
  save(close) {
    const $ctrl = this;
    var tempActivity = Object.assign({}, $ctrl.model.activity);
    if ($ctrl.model.customer) {
      tempActivity.retailerId = $ctrl.model.customer.id;
      tempActivity.customerName = $ctrl.model.customer.companyName;
    }
    if ($ctrl.model.prospect) {
      tempActivity.prospectId = $ctrl.model.prospect.id;
      tempActivity.prospectName = $ctrl.model.prospect.companyName;
    }
    if ($ctrl.model.activity.scheduledForUser) {
      tempActivity.scheduledForUserName =
        $ctrl.model.activity.scheduledForUser.userName;
    }

    if ($ctrl.model.activity.id) {
      $ctrl.bus
        .send("UpdateActivity.json?jsconfig=ua,uaa", tempActivity)
        .then(function(response) {
          $ctrl.$emit("activitySaved", $ctrl);
          if (
            activityConfig.googleApi &&
            $ctrl.model.activity.scheduledByUserName ===
              $ctrl.model.activity.scheduledForUserName
          ) {
            $ctrl.updateGoogle("update");
          }
          if (
            activityConfig.outlookApi &&
            localStorage.token &&
            $ctrl.model.activity.scheduledByUserName ===
              $ctrl.model.activity.scheduledForUserName
          ) {
            $ctrl.updateOutlook("update");
          }
          if (close) {
            $ctrl.$close($ctrl.model);
          }
          $ctrl.duplicating = false;
        });
    } else {
      if (tempActivity.retailerId) {
        var otherActivities = new AutoQuery({
          url:
            "QueryActivities.json?retailerId=" +
            tempActivity.retailerId +
            "&startDateGreaterThan=" +
            tempActivity.startDate.format("MM/DD/YYYY") +
            "&startDateLessThan=" +
            tempActivity.startDate
              .clone()
              .add("days", 1)
              .format("MM/DD/YYYY"),
          orderBy: "-StartDate",
          autoLoad: true,
          onLoaded: function(args) {
            if (args.total > 0) {
              modals
                .confirm(
                  "There is already an activity for this customer on " +
                    tempActivity.startDate.format("MM/DD/YYYY"),
                  "Create Activity"
                )
                .result.then(function() {
                  $ctrl.commitActivity(tempActivity);
                });
            } else {
              $ctrl.commitActivity(tempActivity);
            }
          },
          pageSize: 10
        });
      } else {
        $ctrl.commitActivity(tempActivity);
      }
    }
  }

  duplicate() {
    const $ctrl = this;
    return modals
      .confirm("Copy this activity?", "Copy Activity")
      .result.then(function() {
        //$ctrl.duplicating = true;
        $ctrl.save(false);
        $ctrl.model.activity.id = "";
        function round(date, duration, method) {
          return moment(Math[method](+date / +duration) * +duration);
        }
        var timezone = moment.tz.guess();
        var date = moment.tz(timezone);
        var startDate = round(date, moment.duration(30, "minutes"), "ceil");
        var endDate = startDate.add("minutes", 60);
        $ctrl.model.activity.scheduledByUserName = $session.userName;
        $ctrl.model.activity.scheduledForUserName = $session.userName;
        $ctrl.model.activity.startDateString = startDate.format(
          "MM/DD/YYYY hh:mm a"
        );
        $ctrl.model.activity.endDateString = endDate.format(
          "MM/DD/YYYY hh:mm a"
        );
        $ctrl.model.activity.timeZone = $ctrl.getEmunTimezone(timezone);
      });
  }

  submit() {
    const $ctrl = this;
    $ctrl.save(true);
  }

  delete() {
    const $ctrl = this;
    $ctrl.$close($ctrl.model);
    return modals
      .confirm("Are you sure?", "Delete Activity")
      .result.then(function() {
        $ctrl.bus
          .send("DeleteActivity.json", $ctrl.model.activity)
          .then(function(response) {
            $ctrl.$emit("activityDeleted", $ctrl);
            if (
              activityConfig.googleApi &&
              localStorage.token &&
              $ctrl.model.activity.scheduledByUserName ==
                $ctrl.model.activity.scheduledForUserName
            ) {
              $ctrl.updateGoogle("delete");
            }
            if (
              activityConfig.outlookApi &&
              localStorage.token &&
              $ctrl.model.activity.scheduledByUserName ==
                $ctrl.model.activity.scheduledForUserName
            ) {
              $ctrl.updateOutlook("delete");
            }
          });
      });
  }

  dismiss() {
    const $ctrl = this;
    //$ctrl.$emit('activitySaved', $ctrl);
    $ctrl.$dismiss();
  }
}

export default ActivityPromptController;
